export const keyCompetenciaServidor: string = 'KEY-COMPETENCIA-CONSULTA_FOLHA';
export const keySequencialServidor: string = 'KEY-SEQUENCIAL-CONSULTA_FOLHA';
export const keyReferenciaDecimo: string = 'KEY-REFERENCIA-CONSULTA_DECIMO';
export const keyCompetenciaRescisao: string = 'KEY-COMPETENCIA-CONSULTA_RESCISAO';
export const keyCompetenciaPagamentoRescisao: string = 'KEY-COMPETENCIA-PAGAMENTO-CONSULTA_RESCISAO';
export const IBGECaucaia: string = "2303709";
